import React from 'react'
import Input from '../../ui/inputs/Input'
import DateInput from '../../ui/inputs/DateInput'
import DeleteIconButton from '../../ui/buttons/DeleteIconButton'

const FinancialOfficerForm = ({ index, officer, onChange, onRemove, canWrite = true }) => {
  const handleChange = (e) => {
    const { name, value } = e.target
    onChange(index, { ...officer, [name]: value })
  }

  return (
    <div className="grid grid-cols-12 gap-4 items-end">
      <div className="col-span-12 md:col-span-11 space-y-4">
        <Input
          name="name"
          label="Nome completo"
          value={officer.name}
          onChange={handleChange}
          required
          disabled={!canWrite}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <Input
            name="kinship"
            label="Parentesco"
            value={officer.kinship}
            onChange={handleChange}
            disabled={!canWrite}
          />
          <Input
            name="cpf"
            label="CPF"
            value={officer.cpf}
            onChange={handleChange}
            disabled={!canWrite}
          />
          <DateInput
            name="birth_date"
            label="Data de nascimento"
            value={officer.birthDate}
            onChange={handleChange}
            disabled={!canWrite}
          />
        </div>
      </div>

      {canWrite && (
        <div className="col-span-12 md:col-span-1 flex justify-center items-end h-full">
          <DeleteIconButton onClick={() => onRemove(index)} />
        </div>
      )}
    </div>
  )
}

export default FinancialOfficerForm
